














































import { Component, Watch } from 'vue-property-decorator';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import UpdateAvatarViewModel from '@/models/Avatars/UpdateAvatarViewModel';
import FileUtils from '@/lib/fileUtils';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
  name: 'EditAgencyAvatar',
  components: {
    Cropper,
  },
})
export default class extends GiganautVueDialog {
  public image_loading = false;
  public selectedFile: File | null = null;
  public avatarStatus = true;
  public avatarSize = 120;
  public img: string | null = null;
  public coordinates: any = null;
  public fileInputKey = 0;

  @Watch('dialog')
  onDialogChanged(newVal: boolean) {
    if (newVal) {
      this.selectedFile = null;
      this.img = null;
      this.fileInputKey++;
    }
  }

  change({ coordinates }: { coordinates: any; canvas: any }) {
    this.coordinates = coordinates;
  }

  onFileSelected(event: any) {
    try {
      this.selectedFile = event.target.files[0];
      this.img = URL.createObjectURL(this.selectedFile as File);
    } catch {
      this.img = null;
    }
  }

  async save() {
    const { canvas } = (this.$refs.cropper as any).getResult();
    if (canvas) {
      const fileExtension = '.' + (this.selectedFile as File).name.split('.').pop();
      const contentType = FileUtils.cleanContentType(fileExtension, (this.selectedFile as File).type);
      const vm = new UpdateAvatarViewModel();
      vm.originFileName = (this.selectedFile as File).name;
      vm.contentType = contentType;
      vm.blobToUpload = await new Promise(resolve => canvas.toBlob(resolve));
      await AgencySettingsModule.editAgencyAvatar(vm);
    }
    this.dialog = false;
    this.$forceUpdate();
  }
}
